<template>
    <div class="col-md-6 m-b">
        <div v-bind:class="[error,'form-group']" :id="'date_'+id">
            <label>{{ name }}</label>
            <div class="input-group date">
                <span class="input-group-addon">
                    <i class="fa-regular fa-calendar-day"></i>
                </span>
                <input type="text" :name="'dynamic_field_'+id" :title="name" :value="value_inner" class="form-control">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value', 'error'],
        data: function () {
            return {
                value_inner: this.value
            }
        },
        watch: {
            value_inner: function (val, oldVal) {
                this.$emit('input', val);
            }
        },
        mounted() {
            let dateField = $('#date_' + this.id + ' .input-group.date');
            dateField.datepicker({
                maxViewMode: 1,
                todayBtn: 'linked',
                language: Laravel.activeLanguage,
                orientation: 'bottom auto'
            }).on('changeDate', () => {
                this.value_inner = $(dateField).find('input').val();
            });
        }
    }
</script>
